import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Ribbon";
import { Categories } from "@/components/site/Categories";
import { Brands } from "@/components/site/Brands";
import { Manifesto } from "@/components/site/Manifesto";
import { RegisterForm } from "@/components/site/RegisterForm";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="bg-[#050505] min-h-screen" data-testid="landing-page">
      <Nav />
      <Hero />
      <Ribbon />
      <Categories />
      <Brands />
      <Manifesto />
      <RegisterForm />
      <Footer />
    </div>
  );
}
